import { tileSizes as widths } from '../wallColumns'
// The wall's three tile sizes, as the width a tile aims for in px; the wall
// turns each into a count of columns (wallColumns). Three named sizes
// replaced a 140–420 slider that carried no label (#277).
const tileSizes = [
  { key: 'S', name: 'Small', px: widths[0] },
  { key: 'M', name: 'Medium', px: widths[1] },
  { key: 'L', name: 'Large', px: widths[2] },
] as const

export function TileSize({ value, onChange }: { value: number; onChange: (px: number) => void }) {
  // Arrow keys move the choice, as in any radio group; only the chosen size is
  // a Tab stop.
  const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key]
    if (!step) return
    e.preventDefault()
    const at = Math.max(0, tileSizes.findIndex((s) => s.px === value))
    const next = tileSizes[(at + step + tileSizes.length) % tileSizes.length]
    onChange(next.px)
    e.currentTarget.querySelector<HTMLElement>(`[data-size="${next.key}"]`)?.focus()
  }
  return (
    <div className="flex items-center gap-2">
      <span id="tile-size" className="text-sm text-zinc-400">Tile size</span>
      <div role="radiogroup" aria-labelledby="tile-size" onKeyDown={onKeyDown} className="flex gap-0.5 p-0.5 rounded-md border border-zinc-800 bg-zinc-900">
        {tileSizes.map((s) => (
          <button
            key={s.key}
            type="button"
            role="radio"
            aria-checked={value === s.px}
            tabIndex={value === s.px ? 0 : -1}
            data-size={s.key}
            aria-label={s.name}
            title={s.name}
            onClick={() => onChange(s.px)}
            className={`w-8 h-7 rounded text-xs font-mono transition-colors ${
              value === s.px ? 'bg-zinc-800 text-zinc-100 font-semibold' : 'text-zinc-400 hover:text-zinc-100'
            }`}
          >
            {s.key}
          </button>
        ))}
      </div>
    </div>
  )
}
